export default [
    {
      name: "Hardware/Software developer",
      id: 1,
      content:
      "Creation of a supervision system in burn-in test on LED technology products with Arduino.",
      image:
      "https://user-images.githubusercontent.com/73825898/171646849-6ff1aaa2-c17a-4668-9990-12292029184d.png",
      tech1:
      "https://img.shields.io/badge/arduino-00979D?style=flat&logo=arduino&logoColor=white",
      tech2: 
      "https://img.shields.io/badge/php-blue",
      tech3:
        "https://img.shields.io/badge/js-yellow",
  
      live: "https://github.com/Adrien-Nicolas/Gestion_deverminage",
      code: "https://github.com/Adrien-Nicolas/Gestion_deverminage",
    },
  
    {
      name: "IT developer (data migration)",
      id: 0,
      content:
      "Data migration between the first and the second version of an application developed internally for the census of equipment startups.",
      image:
        "https://skills.thijs.gg/icons?i=django,python,postgresql",
      tech1:
        "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
      tech2:
        "https://img.shields.io/badge/django-092E20?style=flat&logo=django&logoColor=white",
      live: "/",
      code: "/"
    },
  
    {
      name: "Robotic developer",
      id: 7,
      content:
        "Design, development and navigation of a robot for harvesting lavender. Develop the human-robot interface for remote monitoring and control",
      image: "https://user-images.githubusercontent.com/73825898/228518049-0c88b516-2f0d-4ade-af2f-5bf1796d5001.png",
      tech1:
        "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
      tech2:
        "https://img.shields.io/badge/ROS-22314E?style=flat&logo=ROS&logoColor=white",
      tech3:
        "https://img.shields.io/badge/C-00599C?style=flat&logo=c&logoColor=white",
      live: "https://github.com/Adrien-Nicolas/Point-cloud-processing-ROS",
      code: "https://github.com/Adrien-Nicolas/Point-cloud-processing-ROS",
    },
  
    {
      name: "Datascientist",
      id: 7,
      content:
        "Development of a solution allowing you to check the conformity of a trame, from a 'schema' file containing the values and indications of a trame. From Charleville fundry plant",
      image: "https://autoplanservices.com/wp-content/uploads/et_temp/STELLANTIS-LOGO-transparent-30163_1080x592.png",

      live: "",
      code: "",
    }
  
  
  ];